import React from "react";
import styled from "styled-components";
import classNames from "classnames";
import TabHeader from "../tabHeader/TabHeader";

interface Props {
  title: JSX.Element,
  body: JSX.Element,
  footer: JSX.Element,
  isOpen: boolean,
  isDark?: boolean,
}

const StyledTab = styled.div`
  display: flex;
  flex-direction: column;

  & .tab__body {
    overflow-y: auto;
  }

  @media (min-width: 481px) {
    width: 100%;

    &.tab--closed {
      cursor: pointer;

      & .tab__header {
        display: none;
      }

      & .tab__title {
        justify-content: center;
        display: flex;
        width: 100%;
      }

      & .tab__body {
        display: none;
      }

      & .tab__footer {
        display: none;
      }
    }

    &.tab--open {
      margin-left: 100px;
      margin-right: 80px;

      & .tab__header {
        flex: 0 0 auto;
      }

      & .tab__title {
        flex: 0 0 auto;
      }

      & .tab__body {
        flex: 5 1 auto;
      }

      & .tab__footer {
        flex: 0 0 auto;
        min-height: 50px;
        padding: 15px 0px;
      }
    }
  }

  @media (max-width: 480px) {
    width: 80%;
    padding: 0 10%;

    &.tab--closed {
      cursor: pointer;

      & .tab__header {
        display: none;
      }

      & .tab__title {
        justify-content: center;
        display: flex;
        width: 100%;
      }

      & .tab__body {
        display: none;
      }

      & .tab__footer {
        display: none;
      }
    }

    &.tab--open {
      & .tab__header {
        flex: 0 0 auto;
      }

      & .tab__title {
        flex: 0 0 auto;
        padding-bottom: 15px;
        display: flex;
        justify-content: center;
      }

      & .tab__body {
        flex: 5 1 auto;
      }

      & .tab__footer {
        flex: 0 0 auto;
        min-height: 50px;
        padding: 15px 0px;
      }
    }
  }
`;

const Tab: React.FC<Props> = ({ title, body, footer, isOpen, isDark = false }) => {
  return (
    <StyledTab className={ classNames('tab', { 'tab--open': isOpen }, { 'tab--closed': !isOpen }) }>
      <div className={ 'tab__header' }>
        <TabHeader darkMode={ isDark } />
      </div>
      <div className={ 'tab__title' }>
        { title }
      </div>
      <div className={ 'tab__body' }>
        { body }
      </div>
      <div className={ 'tab__footer' }>
        { footer }
      </div>
    </StyledTab>
  )
};

export default Tab;
